<script>
import ModelTabShow from "../models/show-tab.vue";
import ModelShow from '@/components/models/show'

import Row from "@/components/models/show/custom-row";

export default {
  extends: ModelTabShow,
  components: {
    ModelShow,
  },
  page: {
    title: "Detail Sale Notes",
  },
  props: {
    cardTitle: {
      default() {
        return undefined;
      },
    },
    resourceRoute: { default: "sale_notes.resume" },
    modelVariable: { default: "resume" },
    denyDelete: { type: Boolean, default: true },
    denyBack: { type: Boolean, default: true },
    denyEdit: {
      type: Boolean,
      default() {
        return !this.$auth.hasJalaTradeRole(["admin", "finances"]);
      },
    },
    printable: { type: Boolean, default: true },
    columns: {
      type: Object,
      default() {
        return {
          [this.modelVariable || "model"]: [
            {
              key: "key",
              label: this.$t("models.key"),
              component: Row,
            },
          ],
        };
      },
    },
    cardAttrs: {
      default() {
        return {
          style: "background: transparent; box-shadow: none; border: none;",
        };
      },
    },
    tableProps: {
      default(){
        return {
          "tbody-tr-class": "main-table",
        }
      }
    }
  },
  watch: {
    model: function (val, oldVal) {
      if (!this.lodash.isEqual(val, oldVal)) {
        if (val.ticket.customer_type !== "brs") this.denyEdit = true;
      }
    },
  },
  data() {
    return {
      title: this.lodash.startCase(this.$t("sale_notes.plural")),
      discountsPartnerVisible: false,
    };
  },
  mounted() {
    this.fetchModel();
  },
  computed: {
    items() {
      return [
        {
          text: this.lodash.startCase(this.$t("sale_notes.plural")),
          href: "/sale_notes",
        },
        {
          text:
            this.model && this.model.id
              ? this.model["name"]
              : this.$route.params.key,
          href: `/sale_notes/${this.$route.params.key}`,
          active: true,
        },
      ];
    },
    tabs() {
      if (this.model.is_unload_order) {
        return this.processingTabs
      } else if (this.model.type === 'local_market') {
        return this.localMarketTabs
      } else if (this.model?.ticket?.customer_type === 'brs') {
        return this.brsTabs
      } else return [];
    },
    processingTabs(){
      return [
        {
          title: 'ADMIN',
          modelMapped: [
            {
              key: "Admin Balancing",
              class: 'd-block d-print-none',
              item: this.model,
              labelClass: 'd-none',
              valueClass: 'bg-white border p-3',
              
              value: {
                props: {
                  item: {
                    type: Array,
                    default() {
                      return [];
                    },
                  },
                },
                data(){
                  return {
                    discountsVisible: false,
                  }
                },
                computed: {
                  fields() {
                    return [
                      {
                        key: "index",
                        label: "No.",
                        sortable: false,
                        thStyle: "font-weight: 600; background: #F9FAFB; width: 10px",
                        tdClass: "fw-bold bg-white"
                      },
                      {
                        key: "size",
                        label: "Nama Barang",
                        formatter: (value) => `Udang Vaname / Size ${value}`,
                        sortable: false,
                        thStyle: "font-weight: 600; background: #F9FAFB; width: 80px",
                        tdClass: "fw-bold bg-white"
                      },
                      {
                        key: "quantity",
                        label: "Biomassa (kg)",
                        tdClass: "text-left fw-bold bg-white",
                        thStyle: "font-weight: 600; background: #F9FAFB; width: 80px",
                        formatter: (value) => {
                          return (
                            (value ? this.$numeral(value).format("0,0.[00]") : "")
                          );
                        },
                      },
                      {
                        key: "unit_price",
                        label: "Harga",
                        thStyle: "font-weight: 600; background: #F9FAFB; width: 80px",
                        tdClass: "fw-bold bg-white",
                        formatter: (value) => {
                          return value
                            ? this.$numeral(value).format("$ 0,[00]")
                            : "";
                        },
                      },
                      {
                        key: "total_price",
                        label: "Jumlah",
                        thStyle: "font-weight: 600; background: #F9FAFB; width: 80px",
                        tdClass: "fw-bold bg-white",
                        formatter: (value) => {
                          return value
                            ? this.$numeral(value).format("$ 0,[00]")
                            : "";
                        },
                      },
                    ];
                  },
                  rowClass() {
                    return "";
                  },
                  value(){
                    return this.item
                  },
                  totalBiomassa(){
                    return this.item.trip?.unload.sale_items.reduce((acc, item) => acc + item.quantity, 0)
                  },
                  subTotal(){
                    return this.item.trip?.unload.sale_items.reduce((acc, item) => acc + item.total_price, 0)
                  },
                  profitShare(){
                    let expenses = this.item.sales_reports.filter(({ category }) => category === 'expense')
                    return expenses.find(({ sales_reportable_type }) => sales_reportable_type === 'App\\Models\\BalancingTransaction') || {}
                  },
                  cogs(){
                    return this.item.sales_reports.filter(({category}) => category === 'cost_of_goods_sold')
                  },
                  groupedBySubCategory(){
                    return this.lodash.groupBy(this.cogs, 'sub_category')
                  },
                  ice(){
                    return this.item.sales_reports.find(({sub_category}) => sub_category === 'ice')?.total || 0
                  },
                  labourCost(){
                    return Math.abs(this.item.sales_reports
                            .filter(({sub_category}) => sub_category === 'labour')
                            .reduce((prev, curr) => {
                              return curr.total += prev
                            }, 0))
                  },
                  shippingCost(){
                    return Math.abs(this.item.sales_reports
                            .filter(({sub_category}) => sub_category === 'delivery')
                            .reduce((prev, curr) => {
                              return curr.total += prev
                            }, 0))
                  },
                  total(){
                    return this.ice + this.labourCost + this.shippingCost + Math.abs(this.item.total_profit) + Math.abs(this.profitShare.total)
                  },
                  transferToPartnerModelMapped(){
                          // <b-td stacked-heading="TRANSFER KE MITRA" class="balancing-field text-success border-0">{{$numeral(total).format('$ 0,0.[000]')}}</b-td>
                          // <b-th stacked-heading="Glazing" class="text-left balancing-field">{{$numeral(Math.abs(ice)).format('$ 0,0.[000]')}}</b-th>
                          // <b-td stacked-heading="Labour Cost" class="balancing-field">{{$numeral(labourCost).format('$ 0,0.[000]')}}</b-td>
                          // <b-td stacked-heading="Shipping Cost" class="balancing-field">{{$numeral(Math.abs(item.total_profit)).format('$ 0,0.[000]')}}</b-td>
                          // <b-td stacked-heading="Bagi Hasil" class="balancing-field">{{$numeral(Math.abs(profitShare.total)).format('$ 0,0.[000]')}}</b-td>
                      return [
                        {
                          key: `Glazing`,
                          value: this.$numeral(Math.abs(this.ice)).format('$ 0,0.[000]'),
                          class: 'row',
                          labelClass: 'col-sm-12 col-md-4 col-xl-3',
                          valueClass: 'col-sm-12 col-md-8 col-xl-9 text-end',
                          showColon: true,
                        },
                        {
                          key: `Labour Cost`,
                          value: this.$numeral(this.labourCost).format('$ 0,0.[000]'),
                          class: 'row',
                          labelClass: 'col-sm-12 col-md-4 col-xl-3',
                          valueClass: 'col-sm-12 col-md-8 col-xl-9 text-end',
                          showColon: true,
                        },
                        {
                          key: `Shipping Cost`,
                          value: this.$numeral(Math.abs(this.shippingCost)).format('$ 0,0.[000]'),
                          class: 'row',
                          labelClass: 'col-sm-12 col-md-4 col-xl-3',
                          valueClass: 'col-sm-12 col-md-8 col-xl-9 text-end',
                          showColon: true,
                        },
                        {
                          key: `Bagi Hasil`,
                          value: this.$numeral(Math.abs(this.profitShare.total)).format('$ 0,0.[000]'),
                          class: 'row',
                          labelClass: 'col-sm-12 col-md-4 col-xl-3',
                          valueClass: 'col-sm-12 col-md-8 col-xl-9 text-end',
                          showColon: true,
                        },
                      ];
                    }
                },
                methods: {
                  findSaleAdditionalItemByName(name){
                    return this.item.sale_additional_items.find(item => item.name === name) || {}
                  }
                },
                template: /*html*/ `
                <div class="p-3 bg-white">
                  <b-table :tbody-tr-class="rowClass" :fields="fields" :items="item.sale_items" borderless outlined>
                    <template v-slot:custom-foot="data">
                      <b-tr>
                        <b-td class="text-left text-success" style="fontWeight: 600 !important" ></b-td>
                        <b-td class="text-left text-success" style="fontWeight: 600 !important" >Subtotal Penjualan</b-td>
                        <b-td class="text-left text-success" style="fontWeight: 600 !important" >{{totalBiomassa}}</b-td>
                        <b-td class="text-left text-success" style="fontWeight: 600 !important" ></b-td>
                        <b-td class="text-left text-success" style="fontWeight: 600 !important" >{{$numeral(subTotal).format('$ 0,0.[000]')}}</b-td>
                      </b-tr>
                    </template>
                  </b-table>
                  <div class="w-100 d-flex flex-column align-items-end">
                    <b-table-simple hover small caption-top stacked borderless class="bg-gray-100" style="width: 40%;">
                      <b-tbody class="px-3 border">
                        <b-tr>
                          <b-th stacked-heading="Nota Panen" class="text-left border-0 balancing-field">{{$numeral(item.trip.total).format('$ 0,0.[000]')}}</b-th>
                          <b-td stacked-heading="Pph" class="balancing-field">{{$numeral(Math.abs(findSaleAdditionalItemByName('PPH 22').total)).format('$ 0,0.[000]')}}</b-td>
                          <b-td stacked-heading="Margin JALA" class="balancing-field">{{$numeral(item.total_service_fee).format('$ 0,0.[000]')}}</b-td>
                          <b-td stacked-heading="TRANSFER KE MITRA" class="balancing-field text-success">{{$numeral(total).format('$ 0,0.[000]')}}</b-td>
                        </b-tr>
                      </b-tbody>
                    </b-table-simple>
                    <b-table-simple hover small caption-top stacked borderless class="bg-gray-100" style="width: 40%">
                      <b-tbody class="px-3 border">
                        <b-tr>
                          <b-td stacked-heading="TRANSFER KE MITRA" class="balancing-field text-success border-0">{{$numeral(total).format('$ 0,0.[000]')}}</b-td>
                          <b-th stacked-heading="Glazing" class="text-left balancing-field">{{$numeral(Math.abs(ice)).format('$ 0,0.[000]')}}</b-th>
                          <b-td stacked-heading="Labour Cost" class="balancing-field">{{$numeral(labourCost).format('$ 0,0.[000]')}}</b-td>
                          <b-td stacked-heading="Shipping Cost" class="balancing-field">{{$numeral(Math.abs(item.shippingCost)).format('$ 0,0.[000]')}}</b-td>
                          <b-td stacked-heading="Bagi Hasil" class="balancing-field">{{$numeral(Math.abs(profitShare.total)).format('$ 0,0.[000]')}}</b-td>
                        </b-tr>
                      </b-tbody>
                    </b-table-simple>
                  </div>
                </div>
                `
              },
            },
            // Print View
            {
              key: 'JALA Logo',
              labelClass: 'd-none',
              valueClass: 'text-center',
              class: 'd-none d-print-block',
              value: {
                template: /*html*/ `
                  <img src="/jala.svg" alt="JALA Logo" class="img-fluid" style="max-width: 200px">
                `
              }
            },            
            {
              key: "Nota Bongkar",
              class: 'd-none d-print-block',
              item: this.model.trip?.unload.sale_items,
              labelClass: 'd-none',
              valueClass: 'bg-gray-100',
              value: {
                props: {
                  item: {
                    type: Array,
                    default() {
                      return [];
                    },
                  },
                },
                computed: {
                  fields() {
                    return [
                      {
                        key: "size",
                        label: "Nama Barang",
                        formatter: (value) => `Udang Vaname / Size ${value}`,
                        sortable: false,
                        style: { width: "1%" },
                        thClass: "bg-primary text-white",
                        tdClass: "fw-bold"
                      },
                      {
                        key: "quantity",
                        label: "Biomassa (kg)",
                        thClass: "text-left bg-primary text-white",
                        tdClass: "text-left fw-bold",
                        formatter: (value) => {
                          return (
                            (value ? this.$numeral(value).format("0,0.[00]") : "")
                          );
                        },
                      },
                      {
                        key: "unit_price",
                        label: "Harga",
                        thClass: "bg-primary text-white",
                        tdClass: "fw-bold",
                        formatter: (value) => {
                          return value
                            ? this.$numeral(value).format("$ 0,[00]")
                            : "";
                        },
                      },
                      {
                        key: "total_price",
                        label: "Jumlah",
                        thClass: "bg-primary text-white",
                        tdClass: "fw-bold",
                        formatter: (value) => {
                          return value
                            ? this.$numeral(value).format("$ 0,[00]")
                            : "";
                        },
                      },
                    ];
                  },
                  rowClass() {
                    return "";
                  },
                  value(){
                    return this.item
                  },
                  totalBiomassa(){
                    return this.item.reduce((acc, item) => acc + item.quantity, 0)
                  },
                  total(){
                    return this.item.reduce((acc, item) => acc + item.total_price, 0)
                  },
                },
                template: /*html*/ `
                <b-table :tbody-tr-class="rowClass" :fields="fields" :items="item" bordered head-variant="primary">
                  <template v-slot:custom-foot="data">
                    <b-tr>
                      <b-td class="text-left text-success" style="fontWeight: 600 !important" >Subtotal Penjualan</b-td>
                      <b-td class="text-left text-success" style="fontWeight: 600 !important" >{{totalBiomassa}}</b-td>
                      <b-td class="text-left text-success" style="fontWeight: 600 !important" ></b-td>
                      <b-td class="text-left text-success" style="fontWeight: 600 !important" >{{$numeral(total).format('$ 0,0.[000]')}}</b-td>
                    </b-tr>
                  </template>
                </b-table>
                `
              },
            },
            {
              key: "Total",
              class: 'd-none d-print-block',
              item: this.model,
              labelClass: "d-none",
              labelStyles: {
                width: "40%",
              },
              // valueStyles: {
              //   width: "40%",
              // },
              labelItemStyles: {
                fontSize: "1rem",
                color: "white",
                margin: "0",
                fontWeight: "400",
              },
              trClass: "text-right",
              valueClass: 'ms-auto balancing ps-3 bg-gray-100',
              value: {
                props: {
                  item: {
                    type: Array,
                    default() {
                      return [];
                    },
                  },
                },
                computed: {
                  rowClass() {
                    return "";
                  },
                  profitShare(){
                    let expenses = this.item.sales_reports.filter(({ category }) => category === 'expense')
                    return expenses.find(({ sales_reportable_type }) => sales_reportable_type === 'App\\Models\\BalancingTransaction') || {}
                  },
                  cogs(){
                    return this.item.sales_reports.filter(({category}) => category === 'cost_of_goods_sold')
                  },
                  groupedBySubCategory(){
                    return this.lodash.groupBy(this.cogs, 'sub_category')
                  },
                  ice(){
                    return this.item.sales_reports.find(({sub_category}) => sub_category === 'ice')?.total || 0
                  },
                  labourCost(){
                    return Math.abs(this.item.sales_reports
                            .filter(({sub_category}) => sub_category === 'labour')
                            .reduce((prev, curr) => {
                              return curr.total += prev
                            }, 0))
                  },
                  shippingCost(){
                    return Math.abs(this.item.sales_reports
                            .filter(({sub_category}) => sub_category === 'delivery')
                            .reduce((prev, curr) => {
                              return curr.total += prev
                            }, 0))
                  },
                  total(){
                    return this.ice + this.labourCost + this.shippingCost + Math.abs(this.item.total_profit) + Math.abs(this.profitShare.total)
                  },
                },
                methods: {
                  findSaleAdditionalItemByName(name){
                    return this.item.sale_additional_items.find(item => item.name === name) || {}
                  }
                },
                template: /*html*/ `
                  <b-table-simple hover small caption-top stacked borderless class="bg-gray-100" style="width: 40%;float: right;">
                    <b-tbody class="px-3 border">
                      <b-tr>
                        <b-th stacked-heading="Nota Panen" class="text-left border-0 balancing-field">{{$numeral(item.trip.total).format('$ 0,0.[000]')}}</b-th>
                        <b-td stacked-heading="Pph" class="balancing-field">{{$numeral(Math.abs(findSaleAdditionalItemByName('PPH 22').total)).format('$ 0,0.[000]')}}</b-td>
                        <b-td stacked-heading="Margin JALA" class="balancing-field">{{$numeral(item.total_service_fee).format('$ 0,0.[000]')}}</b-td>
                        <b-td stacked-heading="TRANSFER KE MITRA" class="balancing-field text-success">{{$numeral(total).format('$ 0,0.[000]')}}</b-td>
                      </b-tr>
                    </b-tbody>
                  </b-table-simple>
                  `,
              },
            },
            {
              key: "Total",
              class: 'd-none d-print-block',
              item: this.model,
              labelClass: "d-none",
              labelStyles: {
                width: "40%",
              },
              // valueStyles: {
              //   width: "40%",
              // },
              labelItemStyles: {
                fontSize: "1rem",
                color: "white",
                margin: "0",
                fontWeight: "400",
              },
              trClass: "text-right",
              valueClass: 'ms-auto balancing ps-3',
              value: {
                props: {
                  item: {
                    type: Array,
                    default() {
                      return [];
                    },
                  },
                },
                computed: {
                  rowClass() {
                    return "";
                  },
                  profitShare(){
                    let expenses = this.item.sales_reports.filter(({ category }) => category === 'expense')
                    return expenses.find(({ sales_reportable_type }) => sales_reportable_type === 'App\\Models\\BalancingTransaction') || {}
                  },
                  cogs(){
                    return this.item.sales_reports.filter(({category}) => category === 'cost_of_goods_sold')
                  },
                  groupedBySubCategory(){
                    return this.lodash.groupBy(this.cogs, 'sub_category')
                  },
                  ice(){
                    return this.item.sales_reports.find(({sub_category}) => sub_category === 'ice')?.total || 0
                  },
                  labourCost(){
                    return Math.abs(this.item.sales_reports
                            .filter(({sub_category}) => sub_category === 'labour')
                            .reduce((prev, curr) => {
                              return curr.total += prev
                            }, 0))
                  },
                  shippingCost(){
                    return Math.abs(this.item.sales_reports
                            .filter(({sub_category}) => sub_category === 'delivery')
                            .reduce((prev, curr) => {
                              return curr.total += prev
                            }, 0))
                  },
                  total(){
                    return this.ice + this.labourCost + this.shippingCost + Math.abs(this.item.total_profit) + Math.abs(this.profitShare.total)
                  },
                },
                methods: {
                  findSaleAdditionalItemByName(name){
                    return this.item.sale_additional_items.find(item => item.name === name) || {}
                  }
                },
                template: /*html*/ `
                  <span>
                    <div class="position-absolute ps-3 w-25" style="left: 18px">
                      <img src="/jala.svg" alt="JALA Logo" class="img-fluid mb-3" style="max-width: 200px">
                      <div class="text-primary fw-light">
                        <p>JALA Office, Ground Floor Sahid J-Walk, Jl. Babarsari No. 2, Janti, Caturtunggal, Depok, Sleman, Daerah Istimewa Yogyakarta, Indonesia 55281</p>
                        <p>Telp: 0274-8000020 (Office)</p>
                      </div> 
                    </div>
                    <b-table-simple hover small caption-top stacked borderless class="bg-gray-100" style="width: 40%;float: right;">
                      <b-tbody class="px-3 border">
                        <b-tr>
                          <b-td stacked-heading="TRANSFER KE MITRA" class="balancing-field text-success border-0">{{$numeral(total).format('$ 0,0.[000]')}}</b-td>
                          <b-th stacked-heading="Glazing" class="text-left balancing-field">{{$numeral(Math.abs(ice)).format('$ 0,0.[000]')}}</b-th>
                          <b-td stacked-heading="Labour Cost" class="balancing-field">{{$numeral(labourCost).format('$ 0,0.[000]')}}</b-td>
                          <b-td stacked-heading="Shipping Cost" class="balancing-field">{{$numeral(Math.abs(item.total_profit)).format('$ 0,0.[000]')}}</b-td>
                          <b-td stacked-heading="Bagi Hasil" class="balancing-field">{{$numeral(Math.abs(profitShare.total)).format('$ 0,0.[000]')}}</b-td>
                        </b-tr>
                      </b-tbody>
                    </b-table-simple>
                  </span>
                  `,
              },
            },
          ],
        },
        {
          title: 'MITRA',
          modelMapped: [
            {
              key: "Admin Balancing",
              class: 'd-block d-print-none',
              item: this.model,
              labelClass: 'd-none',
              valueClass: 'bg-white border p-3',
              
              value: {
                props: {
                  item: {
                    type: Array,
                    default() {
                      return [];
                    },
                  },
                },
                computed: {
                  fields() {
                    return [
                      {
                        key: "size",
                        label: "Nama Barang",
                        formatter: (value) => `Udang Vaname / Size ${value}`,
                        sortable: false,
                        thStyle: "font-weight: 600; background: #F9FAFB; width: 80px",
                        tdClass: "fw-bold bg-white"
                      },
                      {
                        key: "quantity",
                        label: "Biomassa (kg)",
                        tdClass: "text-left fw-bold bg-white",
                        thStyle: "font-weight: 600; background: #F9FAFB; width: 80px",
                        formatter: (value) => {
                          return (
                            (value ? this.$numeral(value).format("0,0.[00]") : "")
                          );
                        },
                      },
                      {
                        key: "unit_price",
                        label: "Harga",
                        thStyle: "font-weight: 600; background: #F9FAFB; width: 80px",
                        tdClass: "fw-bold bg-white",
                        formatter: (value) => {
                          return value
                            ? this.$numeral(value).format("$ 0,[00]")
                            : "";
                        },
                      },
                      {
                        key: "total_price",
                        label: "Jumlah",
                        thStyle: "font-weight: 600; background: #F9FAFB; width: 80px",
                        tdClass: "fw-bold bg-white",
                        formatter: (value) => {
                          return value
                            ? this.$numeral(value).format("$ 0,[00]")
                            : "";
                        },
                      },
                    ];
                  },
                  rowClass() {
                    return "";
                  },
                  value(){
                    return this.item
                  },
                  totalBiomassa(){
                    return this.item.trip?.unload.sale_items.reduce((acc, item) => acc + item.quantity, 0)
                  },
                  subTotal(){
                    return this.item.trip?.unload.sale_items.reduce((acc, item) => acc + item.total_price, 0)
                  },
                  profitShare(){
                    let expenses = this.item.sales_reports.filter(({ category }) => category === 'expense')
                    return expenses.find(({ sales_reportable_type }) => sales_reportable_type === 'App\\Models\\BalancingTransaction') || {}
                  },
                  cogs(){
                    return this.item.sales_reports.filter(({category}) => category === 'cost_of_goods_sold')
                  },
                  groupedBySubCategory(){
                    return this.lodash.groupBy(this.cogs, 'sub_category')
                  },
                  ice(){
                    return this.item.sales_reports.find(({sub_category}) => sub_category === 'ice')?.total || 0
                  },
                  labourCost(){
                    return Math.abs(this.item.sales_reports
                            .filter(({sub_category}) => sub_category === 'labour')
                            .reduce((prev, curr) => {
                              return curr.total += prev
                            }, 0))
                  },
                  shippingCost(){
                    return Math.abs(this.item.sales_reports
                            .filter(({sub_category}) => sub_category === 'delivery')
                            .reduce((prev, curr) => {
                              return curr.total += prev
                            }, 0))
                  },
                  total(){
                    return this.ice + this.labourCost + this.shippingCost + Math.abs(this.item.total_profit) + Math.abs(this.profitShare.total)
                  },
                },
                methods: {
                  findSaleAdditionalItemByName(name){
                    return this.item.sale_additional_items.find(item => item.name === name) || {}
                  }
                },
                template: /*html*/ `
                <div class="p-3 bg-white">
                  <b-table :tbody-tr-class="rowClass" :fields="fields" :items="item.trip?.unload.sale_items" borderless outlined>
                    <template v-slot:custom-foot="data">
                      <b-tr>
                        <b-td class="text-left text-success" style="fontWeight: 600 !important" >Subtotal Penjualan</b-td>
                        <b-td class="text-left text-success" style="fontWeight: 600 !important" >{{totalBiomassa}}</b-td>
                        <b-td class="text-left text-success" style="fontWeight: 600 !important" ></b-td>
                        <b-td class="text-left text-success" style="fontWeight: 600 !important" >{{$numeral(subTotal).format('$ 0,0.[000]')}}</b-td>
                      </b-tr>
                    </template>
                  </b-table>
                  <div class="w-100 d-flex flex-column align-items-center">
                    <b-table-simple hover small caption-top stacked borderless class="bg-gray-100" style="width: 40%;">
                      <b-tbody class="px-3 border">
                        <b-tr>
                          <b-th stacked-heading="Nota Panen" class="text-left border-0 balancing-field">{{$numeral(item.trip.total).format('$ 0,0.[000]')}}</b-th>
                          <b-td stacked-heading="Pph" class="balancing-field">{{$numeral(Math.abs(findSaleAdditionalItemByName('PPH 22').total)).format('$ 0,0.[000]')}}</b-td>
                          <b-td stacked-heading="Margin JALA" class="balancing-field">{{$numeral(item.total_service_fee).format('$ 0,0.[000]')}}</b-td>
                          <b-td stacked-heading="TRANSFER KE MITRA" class="balancing-field text-success">{{$numeral(total).format('$ 0,0.[000]')}}</b-td>
                        </b-tr>
                      </b-tbody>
                    </b-table-simple>
                  </div>
                </div>
                `
              },
            },
            // Print View
            {
              key: 'JALA Logo',
              labelClass: 'd-none',
              valueClass: 'text-center',
              class: 'd-none d-print-block',
              value: {
                template: /*html*/ `
                  <img src="/jala.svg" alt="JALA Logo" class="img-fluid" style="max-width: 200px">
                `
              }
            },            
            {
              key: "Nota Bongkar",
              class: 'd-none d-print-block',
              item: this.model.trip?.unload.sale_items,
              labelClass: 'd-none',
              valueClass: 'bg-gray-100',
              value: {
                props: {
                  item: {
                    type: Array,
                    default() {
                      return [];
                    },
                  },
                },
                computed: {
                  fields() {
                    return [
                      {
                        key: "size",
                        label: "Nama Barang",
                        formatter: (value) => `Udang Vaname / Size ${value}`,
                        sortable: false,
                        style: { width: "1%" },
                        thClass: "bg-primary text-white",
                        tdClass: "fw-bold"
                      },
                      {
                        key: "quantity",
                        label: "Biomassa (kg)",
                        thClass: "text-left bg-primary text-white",
                        tdClass: "text-left fw-bold",
                        formatter: (value) => {
                          return (
                            (value ? this.$numeral(value).format("0,0.[00]") : "")
                          );
                        },
                      },
                      {
                        key: "unit_price",
                        label: "Harga",
                        thClass: "bg-primary text-white",
                        tdClass: "fw-bold",
                        formatter: (value) => {
                          return value
                            ? this.$numeral(value).format("$ 0,[00]")
                            : "";
                        },
                      },
                      {
                        key: "total_price",
                        label: "Jumlah",
                        thClass: "bg-primary text-white",
                        tdClass: "fw-bold",
                        formatter: (value) => {
                          return value
                            ? this.$numeral(value).format("$ 0,[00]")
                            : "";
                        },
                      },
                    ];
                  },
                  rowClass() {
                    return "";
                  },
                  value(){
                    return this.item
                  },
                  totalBiomassa(){
                    return this.item.reduce((acc, item) => acc + item.quantity, 0)
                  },
                  total(){
                    return this.item.reduce((acc, item) => acc + item.total_price, 0)
                  },
                },
                template: /*html*/ `
                <b-table :tbody-tr-class="rowClass" :fields="fields" :items="item" bordered head-variant="primary">
                  <template v-slot:custom-foot="data">
                    <b-tr>
                      <b-td class="text-left text-success" style="fontWeight: 600 !important" >Subtotal Penjualan</b-td>
                      <b-td class="text-left text-success" style="fontWeight: 600 !important" >{{totalBiomassa}}</b-td>
                      <b-td class="text-left text-success" style="fontWeight: 600 !important" ></b-td>
                      <b-td class="text-left text-success" style="fontWeight: 600 !important" >{{$numeral(total).format('$ 0,0.[000]')}}</b-td>
                    </b-tr>
                  </template>
                </b-table>
                `
              },
            },
            {
              key: "Total",
              class: 'd-none d-print-block',
              item: this.model,
              labelClass: "d-none",
              labelStyles: {
                width: "40%",
              },
              // valueStyles: {
              //   width: "40%",
              // },
              labelItemStyles: {
                fontSize: "1rem",
                color: "white",
                margin: "0",
                fontWeight: "400",
              },
              trClass: "text-right",
              valueClass: 'ms-auto balancing ps-3 bg-gray-100',
              value: {
                props: {
                  item: {
                    type: Array,
                    default() {
                      return [];
                    },
                  },
                },
                computed: {
                  rowClass() {
                    return "";
                  },
                  profitShare(){
                    let expenses = this.item.sales_reports.filter(({ category }) => category === 'expense')
                    return expenses.find(({ sales_reportable_type }) => sales_reportable_type === 'App\\Models\\BalancingTransaction') || {}
                  },
                  cogs(){
                    return this.item.sales_reports.filter(({category}) => category === 'cost_of_goods_sold')
                  },
                  groupedBySubCategory(){
                    return this.lodash.groupBy(this.cogs, 'sub_category')
                  },
                  ice(){
                    return this.item.sales_reports.find(({sub_category}) => sub_category === 'ice')?.total || 0
                  },
                  labourCost(){
                    return Math.abs(this.item.sales_reports
                            .filter(({sub_category}) => sub_category === 'labour')
                            .reduce((prev, curr) => {
                              return curr.total += prev
                            }, 0))
                  },
                  shippingCost(){
                    return Math.abs(this.item.sales_reports
                            .filter(({sub_category}) => sub_category === 'delivery')
                            .reduce((prev, curr) => {
                              return curr.total += prev
                            }, 0))
                  },
                  total(){
                    return this.ice + this.labourCost + this.shippingCost + Math.abs(this.item.total_profit) + Math.abs(this.profitShare.total)
                  },
                },
                methods: {
                  findSaleAdditionalItemByName(name){
                    return this.item.sale_additional_items.find(item => item.name === name) || {}
                  }
                },
                template: /*html*/ `
                  <b-table-simple hover small caption-top stacked borderless class="bg-gray-100" style="width: 40%;float: right;">
                    <b-tbody class="px-3 border">
                      <b-tr>
                        <b-th stacked-heading="Nota Panen" class="text-left border-0 balancing-field">{{$numeral(item.trip.total).format('$ 0,0.[000]')}}</b-th>
                        <b-td stacked-heading="Pph" class="balancing-field">{{$numeral(Math.abs(findSaleAdditionalItemByName('PPH 22').total)).format('$ 0,0.[000]')}}</b-td>
                        <b-td stacked-heading="Margin JALA" class="balancing-field">{{$numeral(item.total_service_fee).format('$ 0,0.[000]')}}</b-td>
                        <b-td stacked-heading="TRANSFER KE MITRA" class="balancing-field text-success">{{$numeral(total).format('$ 0,0.[000]')}}</b-td>
                      </b-tr>
                    </b-tbody>
                  </b-table-simple>
                  `,
              },
            },
          ],
        },
      ];
    },
    localMarketTabs(){
      return []
    },
    brsTabs(){
      return [
        {
          title: 'ADMIN',
          modelMapped: [
            {
              key: 'JALA Logo',
              labelClass: 'd-none',
              valueClass: 'text-center',
              class: 'd-none d-print-block',
              value: {
                template: /*html*/ `
                  <img src="/jala.svg" alt="JALA Logo" class="img-fluid" style="max-width: 200px">
                `
              }
            },
            {
              key: `Nota Panen`,
              label: {
                template: /*html*/`
                  <div class="custom-label bg-primary text-white p-3 py-2 gap-3 align-items-center" style="display: flex;">
                    <router-link :to="'/purchase_orders/${this.model.purchase_order.id}'">
                      <h6 class="label-item border border-top-0 border-start-0 border-end-0" style="font-size: 1rem; color: white; margin: 0px; font-weight: 400;">
                        Nota Panen
                      </h6>
                    </router-link>
                    <div style="font-size: 1rem; color: white; margin: 0px; font-weight: 400;">${this.$moment.utc(this.model.purchase_order.ordered_at).local().format('DD MMM YYYY')}</div>
                  </div>
                `
              },
              // class: 'd-none d-print-block',
              item: this.model.sale_items,
              labelClass: "bg-primary text-white p-3 ",
              labelItemStyles: {
                fontSize: "1rem",
                color: "white",
                margin: "0",
                fontWeight: "400",
              },
              valueClass: 'bg-gray-100 px-2 border',
              value: {
                props: {
                  item: {
                    type: Array,
                    default() {
                      return [];
                    },
                  },
                },
                computed: {
                  fields() {
                    return [
                      // index
                      { key: 'index', label: 'No', sortable: false, style: { width: '1%' } },
                      {
                        key: "quantity",
                        label: "Biomassa",
                        sortable: false,
                        style: { width: "1%" },
                        thClass: "text-raven",
                        thStyle: "font-weight: 600",
                        tdClass: "fw-bold",
                      },
                      {
                        key: "size",
                        label: "Size",
                        sortable: false,
                        style: { width: "1%" },
                        thClass: "text-raven",
                        thStyle: "font-weight: 600",
                        tdClass: "fw-bold",
                      },
                      {
                        key: "unit_price",
                        label: "Harga",
                        thClass: "text-raven",
                        thStyle: "font-weight: 600",
                        tdClass: "fw-bold",
                        formatter: (value) =>
                          this.$numeral(value).format("$ 0,0.[000]"),
                      },
                      {
                        key: "total_price",
                        label: "Jumlah",
                        thClass: "text-raven",
                        thStyle: "font-weight: 600",
                        tdClass: "fw-bold",
                        formatter: (value) =>
                          this.$numeral(value).format("$ 0,0.[000]"),
                      },

                    ];
                  },
                  rowClass() {
                    return "";
                  },
                  totalBiomassa() {
                    return this.$numeral(
                      this.item.reduce((acc, cur) => acc + cur.quantity, 0)
                    ).format("0,0.[000]");
                  },
                  total(){
                    return this.$numeral(
                      this.item.reduce((acc, cur) => acc + cur.total_price, 0)
                    ).format("$ 0,0.[000]");
                  }
                },
                template: /*html*/ `
                    <b-table :tbody-tr-class="rowClass" :fields="fields" :items="item" borderless>
                      <template v-slot:custom-foot="data">
                        <b-tr>
                          <b-td class="text-left text-success" style="fontWeight: 600 !important" ></b-td>
                          <b-td class="text-left text-success" style="fontWeight: 600 !important" ></b-td>
                          <b-td class="text-left text-success" style="fontWeight: 600 !important" ></b-td>
                          <b-td class="text-left text-success" style="fontWeight: 600 !important" >{{totalBiomassa}}</b-td>
                          <b-td class="text-left text-success" style="fontWeight: 600 !important" >{{total}}</b-td>
                        </b-tr>
                      </template>
                    </b-table>
                  `,
              },
            },
            {
              key: `Penerimaan Penjualan`,
              label: {
                template: /*html*/`
                  <div class="custom-label bg-primary text-white p-3 py-2 gap-3 align-items-center" style="display: flex;">
                    <router-link :to="'/sale_invoices/${this.model.id}'">
                      <h6 class="label-item border border-top-0 border-start-0 border-end-0" style="font-size: 1rem; color: white; margin: 0px; font-weight: 400;">
                        Penerimaan Penjualan
                      </h6>
                    </router-link>
                    <div style="font-size: 1rem; color: white; margin: 0px; font-weight: 400;">${this.$moment.utc(this.model.purchase_order.ordered_at).local().format('DD MMM YYYY')}</div>
                  </div>
                `
              },
              // class: 'd-none d-print-block',
              item: this.model.payments,
              labelClass: "bg-primary text-white p-3 ",
              labelItemStyles: {
                fontSize: "1rem",
                color: "white",
                margin: "0",
                fontWeight: "400",
              },
              valueClass: 'bg-gray-100 px-2 border',
              value: {
                props: {
                  item: {
                    type: Array,
                    default() {
                      return [];
                    },
                  },
                },
                computed: {
                  fields() {
                    return [
                      // index
                      { key: 'id', label: 'No.Penjualan', sortable: false, style: { width: '1%' } },
                      {
                        key: "paid_at",
                        label: "Tanggal",
                        sortable: false,
                        style: { width: "1%" },
                        thClass: "text-raven",
                        thStyle: "font-weight: 600",
                        tdClass: "fw-bold",
                      },
                      {
                        key: "nominal",
                        label: "Nominal",
                        sortable: false,
                        style: { width: "1%" },
                        thClass: "text-raven",
                        thStyle: "font-weight: 600",
                        tdClass: "fw-bold",
                        formatter: (value) =>
                          this.$numeral(value).format("$ 0,0.[000]"),
                      },
                      {
                        key: "from_bank_account",
                        label: "Pengirim",
                        sortable: false,
                        style: { width: "1%" },
                        thClass: "text-raven",
                        thStyle: "font-weight: 600",
                        tdClass: "fw-bold",
                        formatter: (value) => `${this.lodash.startCase(value.customer.name)} - ${value.account_number} - ${value.bank.name}`
                      },
                      {
                        key: "to_bank_account",
                        label: "Penerima",
                        sortable: false,
                        style: { width: "1%" },
                        thClass: "text-raven",
                        thStyle: "font-weight: 600",
                        tdClass: "fw-bold",
                        formatter: (value) => `${this.lodash.startCase(value.customer.name)} - ${value.account_number} - ${value.bank.name}`
                      },
                    ];
                  },
                  rowClass() {
                    return "";
                  },
                  totalBiomassa() {
                    return this.$numeral(
                      this.item.reduce((acc, cur) => acc + cur.quantity, 0)
                    ).format("0,0.[000]");
                  },
                  total(){
                    return this.$numeral(
                      this.item.reduce((acc, cur) => acc + cur.total_price, 0)
                    ).format("$ 0,0.[000]");
                  }
                },
                template: /*html*/ `
                    <b-table :tbody-tr-class="rowClass" :fields="fields" :items="item" borderless>
                      
                    </b-table>
                  `,
              },
            },
          ],
        },
        {
          title: 'MITRA',
          modelMapped: [
            {
              key: 'JALA Logo',
              labelClass: 'd-none',
              valueClass: 'text-center',
              class: 'd-none d-print-block',
              value: {
                template: /*html*/ `
                  <img src="/jala.svg" alt="JALA Logo" class="img-fluid" style="max-width: 200px">
                `
              }
            },
            {
              key: `Nota Panen`,
              label: {
                template: /*html*/`
                  <div class="custom-label bg-primary text-white p-3 py-2 gap-3 align-items-center" style="display: flex;">
                    <router-link :to="'/purchase_orders/${this.model.purchase_order.id}'">
                      <h6 class="label-item border border-top-0 border-start-0 border-end-0" style="font-size: 1rem; color: white; margin: 0px; font-weight: 400;">
                        Nota Panen
                      </h6>
                    </router-link>
                    <div style="font-size: 1rem; color: white; margin: 0px; font-weight: 400;">${this.$moment.utc(this.model.purchase_order.ordered_at).local().format('DD MMM YYYY')}</div>
                  </div>
                `
              },
              // class: 'd-none d-print-block',
              item: this.model.sale_items,
              labelClass: "bg-primary text-white p-3 ",
              labelItemStyles: {
                fontSize: "1rem",
                color: "white",
                margin: "0",
                fontWeight: "400",
              },
              valueClass: 'bg-gray-100 px-2 border',
              value: {
                props: {
                  item: {
                    type: Array,
                    default() {
                      return [];
                    },
                  },
                },
                computed: {
                  fields() {
                    return [
                      // index
                      { key: 'index', label: 'No', sortable: false, style: { width: '1%' } },
                      {
                        key: "quantity",
                        label: "Biomassa",
                        sortable: false,
                        style: { width: "1%" },
                        thClass: "text-raven",
                        thStyle: "font-weight: 600",
                        tdClass: "fw-bold",
                      },
                      {
                        key: "size",
                        label: "Size",
                        sortable: false,
                        style: { width: "1%" },
                        thClass: "text-raven",
                        thStyle: "font-weight: 600",
                        tdClass: "fw-bold",
                      },
                      {
                        key: "unit_price",
                        label: "Harga",
                        thClass: "text-raven",
                        thStyle: "font-weight: 600",
                        tdClass: "fw-bold",
                        formatter: (value) =>
                          this.$numeral(value).format("$ 0,0.[000]"),
                      },
                      {
                        key: "total_price",
                        label: "Jumlah",
                        thClass: "text-raven",
                        thStyle: "font-weight: 600",
                        tdClass: "fw-bold",
                        formatter: (value) =>
                          this.$numeral(value).format("$ 0,0.[000]"),
                      },

                    ];
                  },
                  rowClass() {
                    return "";
                  },
                  totalBiomassa() {
                    return this.$numeral(
                      this.item.reduce((acc, cur) => acc + cur.quantity, 0)
                    ).format("0,0.[000]");
                  },
                  total(){
                    return this.$numeral(
                      this.item.reduce((acc, cur) => acc + cur.total_price, 0)
                    ).format("$ 0,0.[000]");
                  }
                },
                template: /*html*/ `
                    <b-table :tbody-tr-class="rowClass" :fields="fields" :items="item" borderless>
                      <template v-slot:custom-foot="data">
                        <b-tr>
                          <b-td class="text-left text-success" style="fontWeight: 600 !important" ></b-td>
                          <b-td class="text-left text-success" style="fontWeight: 600 !important" ></b-td>
                          <b-td class="text-left text-success" style="fontWeight: 600 !important" ></b-td>
                          <b-td class="text-left text-success" style="fontWeight: 600 !important" >{{totalBiomassa}}</b-td>
                          <b-td class="text-left text-success" style="fontWeight: 600 !important" >{{total}}</b-td>
                        </b-tr>
                      </template>
                    </b-table>
                  `,
              },
            },
            {
              key: `Penerimaan Penjualan`,
              label: {
                template: /*html*/`
                  <div class="custom-label bg-primary text-white p-3 py-2 gap-3 align-items-center" style="display: flex;">
                    <router-link :to="'/sale_invoices/${this.model.id}'">
                      <h6 class="label-item border border-top-0 border-start-0 border-end-0" style="font-size: 1rem; color: white; margin: 0px; font-weight: 400;">
                        Penerimaan Penjualan
                      </h6>
                    </router-link>
                    <div style="font-size: 1rem; color: white; margin: 0px; font-weight: 400;">${this.$moment.utc(this.model.purchase_order.ordered_at).local().format('DD MMM YYYY')}</div>
                  </div>
                `
              },
              // class: 'd-none d-print-block',
              item: this.model.payments,
              labelClass: "bg-primary text-white p-3 ",
              labelItemStyles: {
                fontSize: "1rem",
                color: "white",
                margin: "0",
                fontWeight: "400",
              },
              valueClass: 'bg-gray-100 px-2 border',
              value: {
                props: {
                  item: {
                    type: Array,
                    default() {
                      return [];
                    },
                  },
                },
                computed: {
                  fields() {
                    return [
                      // index
                      { key: 'id', label: 'No.Penjualan', sortable: false, style: { width: '1%' } },
                      {
                        key: "paid_at",
                        label: "Tanggal",
                        sortable: false,
                        style: { width: "1%" },
                        thClass: "text-raven",
                        thStyle: "font-weight: 600",
                        tdClass: "fw-bold",
                      },
                      {
                        key: "nominal",
                        label: "Nominal",
                        sortable: false,
                        style: { width: "1%" },
                        thClass: "text-raven",
                        thStyle: "font-weight: 600",
                        tdClass: "fw-bold",
                        formatter: (value) =>
                          this.$numeral(value).format("$ 0,0.[000]"),
                      },
                      {
                        key: "from_bank_account",
                        label: "Pengirim",
                        sortable: false,
                        style: { width: "1%" },
                        thClass: "text-raven",
                        thStyle: "font-weight: 600",
                        tdClass: "fw-bold",
                        formatter: (value) => `${this.lodash.startCase(value.customer.name)} - ${value.account_number} - ${value.bank.name}`
                      },
                      {
                        key: "to_bank_account",
                        label: "Penerima",
                        sortable: false,
                        style: { width: "1%" },
                        thClass: "text-raven",
                        thStyle: "font-weight: 600",
                        tdClass: "fw-bold",
                        formatter: (value) => `${this.lodash.startCase(value.customer.name)} - ${value.account_number} - ${value.bank.name}`
                      },
                    ];
                  },
                  rowClass() {
                    return "";
                  },
                  totalBiomassa() {
                    return this.$numeral(
                      this.item.reduce((acc, cur) => acc + cur.quantity, 0)
                    ).format("0,0.[000]");
                  },
                  total(){
                    return this.$numeral(
                      this.item.reduce((acc, cur) => acc + cur.total_price, 0)
                    ).format("$ 0,0.[000]");
                  }
                },
                template: /*html*/ `
                    <b-table :tbody-tr-class="rowClass" :fields="fields" :items="item" borderless>
                      
                    </b-table>
                  `,
              },
            },
          ],
        },
      ]
    },
  },
  methods: {
    pills(){
      return [
        {
          label: 'Detail',
          active: (this.$route.name === 'sale_notes.show'),
          onClick: () => this.$router.push({ name: 'sale_notes.show', params: { key: this.$route.params.key, model: this.model } })
        },
        {
          label: 'Balancing',
          active: (this.$route.name === 'sale_notes.balancing'),
          onClick: () => this.$router.push({ name: 'sale_notes.balancing', params: { key: this.$route.params.key, model: this.model } })
        },
        {
          label: 'Resume',
          active: (this.$route.name === 'sale_notes.resume'),
          onClick: () => this.$router.push({ name: 'sale_notes.resume', params: { key: this.$route.params.key, model: this.model } })
        },
      ]
    },
    delete() {
      return this.$axios.delete(`/sale_orders/${this.$route.params.key}`);
    },
    fetchModel() {
      // if model in params
      // if (this.$route.params.model) {
      //   this.model = this.$route.params.model;
      //   this.loading = false;
      //   return;
      // }
      this.loading = true;
      return this.$axios
        .get(`/sale_orders/${this.$route.params.key}`, {
          params: {
            with: [
              "creator",
              "customer",
              "purchase_order.customer",
              "purchase_order.product",
              "sale_additional_items",
              "sale_items.purchase_item.purchase_order.customer",
              "sale_items.purchase_item.purchase_order.product",
              "sale_items.trip_item.purchase_item",
              "sale_items.trip_item.purchase_order.customer",
              "sale_items.trip_item.purchase_order.product",
              "trip.customer",
              "ticket",
              "trip.trip_items.purchase_item",
              "trip.delivery_order.customer",
              "trip.vehicle",
              "trip.driver",
              "trip.unload.sale_items.trip_item.purchase_item",
              "trip.unload.sale_items.product",
              "sales_reports.sales_reportable",
              "operational_costs",
              "payments.from_bank_account",
              "payments.from_bank_account.bank",
              "payments.from_bank_account.customer",
              "payments.to_bank_account",
              "payments.to_bank_account.bank",
              "payments.to_bank_account.customer",
            ].join(","),
          },
        })
        .then((response) => {
          const {
            data: { data },
          } = response;
          this.model = {
            ...this.modifyModelResponse(data),
            additional_fees: data.sale_additional_items.filter(
              (item) => item.total > 0
            ),
            discounts: data.sale_additional_items.filter(
              (item) => item.total < 0
            ),
          };
          return response;
        })
        .catch((error) => this.failedAlert(error))
        .finally(() => (this.loading = false));
    },
    modifyModelResponse(saleOrder) {
      let model = saleOrder;
      const trip_item_ids = [];
      if(model.trip){
        model.trip.trip_items = model.trip.trip_items.map((item, index) => ({...item, index: index + 1}))
      }
      if(model.sale_items){
        model.sale_items = model.sale_items.map((item, index) => ({...item, index: index + 1}))
      }
      if(model.trip?.unload?.sale_items){
        model.trip.unload.sale_items = model.trip?.unload.sale_items.map((item) => {
            // item.size_performance =
            //   ((item.initial_size - item.size) /
            //     item.initial_size) *
            //   100;
            if (!trip_item_ids.includes(item.trip_item_id)) {
              trip_item_ids.push(item.trip_item_id);
              item._index = trip_item_ids.length;
              if(item._index){
                item.rowspan = model.trip.unload.sale_items.filter(
                  (sale_item) => sale_item.trip_item_id === item.trip_item_id
                ).length;
              }
              item.estimated_size =
                item.initial_size * 0.9;
              item.estimated_quantity =
                item.initial_quantity * 1.12;
              // const totalQuantity = model.trip?.unload.sale_items
              //   .filter(
              //     (sale_item) => sale_item.trip_item_id === item.trip_item_id
              //   )
              //   .reduce((acc, cur) => acc + cur.quantity, 0);
              // item.quantity_performance =
              //   ((totalQuantity - item.initial_quantity) /
              //     item.initial_quantity) *
              //   100;
            } else {
              item.trip_item_id = null;
              item.shrimp = null;
              item.trip_item = null;
              item.quantity_performance = null;
            }
            return item;
          });
      //   if (saleOrder.ticket.customer_type === 'brs') {
      //     model = this.brsSaleOrderModel(saleOrder)
      //   } else {
      //     if (saleOrder.type === 'unload') {
      //       model = this.processingSaleOrderModel(saleOrder)
      //     } else if(saleOrder.type === 'local_market') {
      //       model = this.localMarketSaleOrderModel(saleOrder)
      //     }
      //   }  
      }
      
      return model;
    },
  },
};
</script>

<style scoped lang="scss">
  ::v-deep .balancing-field::before {
    text-align: left !important;
  }
  ::v-deep .balancing-field {
    font-weight: bold;
  }

  * {
    font-family: 'Lato', sans-serif;
    color: #161B4D ;
  }

  ::v-deep .custom-value > * {
    color: #161B4D !important;
  }
  ::v-deep td, ::v-deep .custom-value > *, ::v-deep th {
    color: #161B4D;
  }
  ::v-deep .page-content {
    background: #EEF3F7;
  }

  ::v-deep .page-content {
    background: #EEF3F7;
  }

  @page {
    size: A4;
  }

  @media print {
    ::v-deep .page-content {
      background: #fff;
      -webkit-print-color-adjust: exact !important;
      color-adjust: exact !important;
      print-color-adjust: exact !important;
    }

    ::v-deep .label-with-date::after {
      content: var(--date);
    }
  }
  
  ::v-deep .mapped-field-row > td {
    padding-block: 0 !important;
    padding-left: 0 !important;
  }

  ::v-deep .main-table > td {
    padding-inline: 0;
  }
  ::v-deep .card-body {
    padding: 30px 0px;
  }

  ::v-deep .collapse-partner-transfer {
    padding: 0;
    translate: -42px;
  }
</style>